import ReactMarkdown from "react-markdown";

export default function RestaurantDescription({ children }) {
  return (
    <div className="app-description">
      <ReactMarkdown
        transformLinkUri={(href) =>
          /^(https?:\/\/|mailto:)/i.test(href) ? href : undefined
        }
        skipHtml
        allowedElements={["p", "br", "strong", "em", "a"]}
        unwrapDisallowed
        components={{
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer">
              {children}
            </a>
          ),
        }}
      >
        {children}
      </ReactMarkdown>
    </div>
  );
}
